import { settingsBreadcrumbs } from '../settings-breadcrumbs';

const cannedResponses_routes = [
  {
    path: 'canned-responses',
    name: 'canned-responses',
    meta: {
      permissions: 'read-canned-responses',
      breadcrumbs: settingsBreadcrumbs({
        label: 'global.sidebar.response_trans',
        route: { name: 's-canned-responses' },
      }),
    },
    children: [
      {
        path: '',
        name: 's-canned-responses',
        component: () => import('@/views/System/Settings/CannedResponses/ResponsesList.vue'),
        meta: {
          permissions: 'read-canned-responses',
        },
      },
    ],
  },
];

export default cannedResponses_routes;
